<app-admin-header></app-admin-header>

<ng-container *ngIf="users?.length;else noData"></ng-container>
<div class="container-fluid p-t-100">
  <!-- <p-scrollPanel [style]="{ width: '100%', height: 'calc(100vh - 20vh)' }"> -->
  <app-virtual-scroll
    class="w-full"
    [data]="userPayload"
    [apiUrl]="approvalList"
    (loadedData)="onDataLoaded($event)"
  >
    <ng-container *ngFor="let wp of users"
      ><app-wp *ngIf="wp?.workpackage || wp?.workpackage" [wp]="wp" (updateState)="updateState($event)"></app-wp
    ></ng-container>
  </app-virtual-scroll>
  <!-- </p-scrollPanel> -->
</div>
<ng-template #noData>
  <app-no-data-found></app-no-data-found>
</ng-template>